import { DateTime } from 'luxon';
import { range } from 'lodash';
import { useEffect, useState } from 'react';
import './todo-adder.css';
import { v4 } from 'uuid';


async function getGoals() {
    const response = await fetch(
      `https://evvki1qmnl.execute-api.us-east-1.amazonaws.com/goals`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  }

export const TodoAdder =  ({ addTodo }) => {
    const [currentItem, setItem] = useState('');
    const [currentDate, setDate] = useState(null);
    const [goals, setGoals] = useState([]);
    const [currentGoal, setCurrentGoal] = useState(null);

    useEffect(() => {
       getGoals().then((goals) => {
           setGoals([{id: v4, name: 'None'}, ...goals]);
       });
    }, [currentDate]);

    const selectGoal = (goalId) => {
        setCurrentGoal(goalId);
    }

    const keyPressHandler = (event, action) => {
        if (event.code === "Enter") {
            action(currentItem, parseInt(currentDate || DateTime.now().toMillis()), currentGoal);
            setItem('');
            setDate(null);
        }
    }

    const changeSelectedDate = (event) => {
        setDate(event.target.value)
    }

    return (
        <div className="todo-adder">
            <input className="todo-input" type="checkbox"/>
            <input className="todo-input" placeholder="Add a new todo" value={currentItem} onChange={(event) => setItem(event.target.value)} onKeyDown={(e) => keyPressHandler(e, addTodo)} type="text"/>
            <select onChange={changeSelectedDate}>
                {range(4).map((days) => {
                    const thisDate = DateTime.now().plus({ days });
                    return (
                    <option selected={currentDate === thisDate.toMillis()} value={thisDate.toMillis()}>{thisDate.toLocaleString(DateTime.DATE_SHORT)}</option>
                    )
                })}
            </select>
            <select onChange={selectGoal}>
                {goals.map((goal) => {
                    return (
                        <option value={goal.id}>{goal.name}</option>
                    )
                })}
            </select>

        </div>
    )
}
